/**
 * @Description: log输出,不同颜色
 * @author JiangJiang
 * @date 2021/7/22 14:25
*/

const LogLevels = {
  trace: 0,
  debug: 1,
  info: 2,
  warn: 3,
  error: 4,
  none: 5,
};

const LogStyles = {
  trace: 'color:lightGray',
  debug: 'color:#61AFEF',
  info: 'color:#89CA78',
  warn: 'color:#E5C07B',
  error: 'color:red',
};

const LOG_LEVEL = 'debug';
const USE_COLOR = true;
/**
 * 日志服务
 */
export default class Logs {
  static trace(tag, ...data) {
    if (LogLevels[LOG_LEVEL] <= LogLevels.trace) {
      if (USE_COLOR) {
        console.log(`%c${tag}`, LogStyles.trace, ...data);
      } else {
        console.log(tag, ...data);
      }
    }
  }

  static debug(tag, ...data) {
    if (LogLevels[LOG_LEVEL] <= LogLevels.debug) {
      if (USE_COLOR) {
        console.log(`%c${tag}`, LogStyles.debug, ...data);
      } else {
        console.log(...data);
      }
    }
  }

  static info(tag, ...data) {
    if (LogLevels[LOG_LEVEL] <= LogLevels.info) {
      if (USE_COLOR) {
        console.log(`%c${tag}`, LogStyles.info, ...data);
      } else {
        console.log(...data);
      }
    }
  }

  static warn(tag, ...data) {
    if (LogLevels[LOG_LEVEL] <= LogLevels.warn) {
      if (USE_COLOR) {
        console.log(`%c${tag}`, LogStyles.warn, ...data);
      } else {
        console.log(...data);
      }
    }
  }

  static error(tag, ...data) {
    if (LogLevels[LOG_LEVEL] <= LogLevels.error) {
      if (USE_COLOR) {
        console.log(`%c${tag}`, LogStyles.error, ...data);
      } else {
        console.log(...data);
      }
    }
  }
}
